import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { FP_PHASE } from '../../../Utils/Constants';


const headerData = [
  { id: 'brand', label: 'MARCA', sort: true, isAll: true },
  { id: 'model', label: 'MODELO', sort: true, isAll: true },
  { id: 'quantity', label: 'QTD', sort: true, isAll: true },
  { id: 'availableqtty', label: 'QTD DISPONÍVEL', sort: true, isAll: false },
  { id: 'formalizationdate', label: 'DATA FORMALIZAÇÃO', sort: true, isAll: true },
  { id: 'lotlppt', label: 'LOTE LPPT', sort: true, isAll: true },
  { id: 'saleschannels', label: 'CANAIS VENDA', sort: false, isAll: true },
  { id: 'icon', label: null, sort: false, isAll: true }
];

const styles = theme => ({
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorder: {
    border: '2px solid #ffffff'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  cellPadding: {
    paddingLeft: '16px'
  },
  tblSort: {
    height: '12px',
    width: '12px',
    margin: '0px 2px'
  },
  noDisplay: {
    display: 'none'
  }
});


class NegotiationTableHeader extends React.Component {

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };


  render() {
    const { order, orderBy, classes, lotStateId } = this.props;

    return (
      <TableHead className={classes.tblHead} >
        <TableRow className={classes.headerHeight} >
          {headerData.map(column => {
            return (
              <TableCell
                key={column.id}
                padding='none'
                sortDirection={orderBy === column.id ? order : false}
                className={classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter, column.sort ? classes.cellPadding : null, lotStateId !== FP_PHASE && !column.isAll ? classes.noDisplay : null)}
              >
                {column.sort ?
                  <TableSortLabel
                    className={classes.tblHeadT}
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                    classes={{ icon: classes.tblSort }}
                  >
                    {column.label}
                  </TableSortLabel>
                  : column.label}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

NegotiationTableHeader.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default NegotiationTableHeader = withStyles(styles)(NegotiationTableHeader);


// WEBPACK FOOTER //
// ./src/components/Negotiation/Lots/NegotiationTableHeader.js